import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.25 6.103c0-.355.186-.676.401-.959.221-.29.349-.634.349-1.003 0-1.035-1.007-1.875-2.25-1.875s-2.25.84-2.25 1.875c0 .37.128.713.349 1.003.215.283.401.604.401.959v0a.64.64 0 0 1-.657.643 48 48 0 0 1-4.163-.3q.28 2.42.315 4.907a.656.656 0 0 1-.658.663v0c-.355 0-.676-.186-.959-.401a1.65 1.65 0 0 0-1.003-.349c-1.036 0-1.875 1.008-1.875 2.25 0 1.243.84 2.25 1.875 2.25.369 0 .713-.128 1.003-.349.283-.215.604-.4.959-.4v0c.31 0 .555.26.532.568a48 48 0 0 1-.642 5.057q2.278.286 4.616.354a.64.64 0 0 0 .657-.643v0c0-.355-.186-.676-.401-.959a1.65 1.65 0 0 1-.349-1.003c0-1.035 1.008-1.875 2.25-1.875 1.243 0 2.25.84 2.25 1.875 0 .37-.128.713-.349 1.003-.215.283-.4.604-.4.96v0c0 .332.277.598.61.578 1.838-.108 3.65-.32 5.427-.629q.405-2.323.582-4.717a.53.53 0 0 0-.533-.57v0c-.355 0-.676.186-.959.401-.29.221-.634.35-1.003.35-1.035 0-1.875-1.008-1.875-2.25 0-1.243.84-2.25 1.875-2.25.37 0 .713.127 1.003.348.283.215.604.401.96.401v0a.656.656 0 0 0 .658-.663 48 48 0 0 0-.37-5.36q-2.83.514-5.766.69a.58.58 0 0 1-.61-.58"
    }, null, -1)
  ])))
}
export default { render: render }